import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-configuracion',
  templateUrl: './configuracion.component.html',
  styleUrls: ['./configuracion.component.scss']
})
export class ConfiguracionComponent implements OnInit {

  sections = {
    configuracion: {
      id: "configuracion",
      label: "Configuración"
    },
    preferenciasCuenta: {
      id: "preferenciasCuenta",
      label: "Preferencias de la cuenta"
    }
  }

  sectionSelected = this.sections.configuracion

  constructor() { }

  ngOnInit(): void {

  }

  goToPreferenciasCuenta() {
    this.sectionSelected = this.sections.preferenciasCuenta
  }

}
